import { ListContactType } from '@bb/contacts';

export const TAB_TITLE_MAP = {
  [ListContactType.Client]: 'Clients',
  [ListContactType.Supplier]: 'Suppliers',
  brokerage: 'My Brokerage',
  [ListContactType.Archived]: 'Archived',
};

export const SORT_KEY_MAP = {
  ascend: 'asc',
  descend: 'desc',
} as const;
